import { NextPage } from 'next';
import Head from 'next/head';
import React from 'react';

import { metaTags } from '../../components/_dummyData';
import { useBreadcrumbs } from '../../components/_shared/Breadcrumbs/BreadcrumbsContext';
import Meta from '../../components/Meta';
import { Representatives } from '../../components/Representatives/Representatives';

interface PageProps {}

const RepresentativesPage: NextPage<PageProps> = () => {
    useBreadcrumbs([{ title: 'Представителям' }]);

    return (
        <>
            <Head>
                <link
                    rel="stylesheet"
                    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
                />
                <link
                    href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap"
                    rel="stylesheet"
                />
            </Head>
            <Meta
                title={metaTags.about.title}
                description={metaTags.about.description}
                url={metaTags.about.url}
            />
            <Representatives />
        </>
    );
};

export default RepresentativesPage;
